import { useEffect, useState } from 'react';
import axios from 'axios';

import API_BASE from "../api";

export default function Contact({ lang }) {
  const [texts, setTexts] = useState(null);

  useEffect(() => {
    axios
      .get(API_BASE + '/api/texts')
      .then((res) => setTexts(res.data))
      .catch((err) => console.error(err));
  }, []);

  if (!texts) return <section className="section">Ładowanie...</section>;

  const t = texts.contact?.[lang];

  if (!t) return null;

  const phoneHref = t.phoneValue
    ? `tel:${t.phoneValue.replace(/[^\d+]/g, '')}`
    : '';

  return (
    <section className="section" id="kontakt">
      <div className="section-header">
        <h2 className="section-title">{t.title}</h2>
        <span className="section-subtitle">{t.subtitle}</span>
      </div>
      <div className="contact-wrapper">
        <div className="contact-row">
          <strong>{t.emailLabel}</strong>{' '}
          <a href={`mailto:${t.emailValue}`}>{t.emailValue}</a>
        </div>
        <div className="contact-row">
          <strong>{t.locationLabel}</strong>{' '}
          {t.locationValue}
        </div>
        <div className="contact-row">
          <strong>{t.instagramLabel}</strong>{' '}
          <a href={`https://www.instagram.com/${t.instagramValue.replace(/^@/, "").replace(/^https?:\/\/(www\.)?instagram\.com\//, "").replace(/\/$/, "")}/`} target="_blank" rel="noreferrer">
            {t.instagramValue}
          </a>
        </div>
        {t.phoneValue && (
          <div className="contact-row">
            <strong>{t.phoneLabel}</strong>{' '}
            <a href={phoneHref}>{t.phoneValue}</a>
          </div>
        )}
        {t.facebookValue && (
          <div className="contact-row">
            <strong>{t.facebookLabel}</strong>{' '}
            <a
              href={t.facebookValue}
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
